export interface IGraylogModel {
    LogLevel: Number;
    Message: string;
    SteamTokenName?: string;
    Data: IGraylogDataModel;
}

export interface IGraylogDataModel {
    customer: string;
    userId: Number;
    action: string;
    startTime?: string;
    endTime?: string;
    duration?: string;
    detail?: any;
}

export class GraylogModel implements IGraylogModel {
    LogLevel: Number;
    Message: string;
    SteamTokenName?: string;
    Data: IGraylogDataModel;

    constructor(option: IGraylogModel) {
        this.LogLevel = option.LogLevel || 4;
        this.Message = option.Message || null;
        this.SteamTokenName = option.SteamTokenName || 'b1fa0775-96a0-4aa5-b338-56fdcb7ca87c';
        this.Data = option.Data || null;
    }
}